'use strict';

const $ = require('jquery');
const isNaN = require('lodash/isNaN');

const SELECTORS = {
    base: '.js-fancy-range',
    minus: '.js-fancy-range__minus',
    plus: '.js-fancy-range__plus',
    input: '.js-fancy-range__input',
    label: '.js-fancy-range__label',
    text: '.js-fancy-range__text'
};

const CLASSES = {
    minusDisabled: 'js-fancy-range__minus--disabled',
    plusDisabled: 'js-fancy-range__plus--disabled'
};

function init() {
    let items = $(SELECTORS.base);

    if (!items.length) {
        return false;
    }

    items.each(function () {
        let item = $(this);

        let input = $(SELECTORS.input, item);
        let minus = $(SELECTORS.minus, item);
        let plus = $(SELECTORS.plus, item);
        let label = $(SELECTORS.label, item);
        let text = $(SELECTORS.text, item);

        let value = parseInt(input.val(), 10);
        let minValue = parseInt(input.attr('min'), 10);
        let maxValue = parseInt(input.attr('max'), 10);

        let singularText = null;
        let pluralText = null;

        if (text.length) {
            singularText = text.data('singularText');
            pluralText = text.data('pluralText');
        }

        let render = function () {
            minus.removeClass(CLASSES.minusDisabled);
            plus.removeClass(CLASSES.plusDisabled);

            if (value === minValue) {
                minus.addClass(CLASSES.minusDisabled);
            }

            if (value === maxValue) {
                plus.addClass(CLASSES.plusDisabled);
            }

            input.val(value);
            label.text(value);

            if (singularText && pluralText) {
                if (value === 1) {
                    text.text(singularText);
                } else {
                    text.text(pluralText);
                }
            }
        };

        minus.on('click', function () {
            if (isNaN(minValue) || value - 1 >= minValue) {
                value--;
            }

            render();
        });

        plus.on('click', function () {
            if (isNaN(maxValue) || value + 1 <= maxValue) {
                value++;
            }

            render();
        });

        render();
    });
}

module.exports = {
    init
};




// WEBPACK FOOTER //
// ./modules/fancyRange.js